// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
application.register("address", AddressController)

import AiSearchController from "./ai_search_controller"
application.register("ai-search", AiSearchController)

import AffirmController from "./affirm_controller"
application.register("affirm", AffirmController)

import Bag__BraintreeController from "./bag/braintree_controller"
application.register("bag--braintree", Bag__BraintreeController)

import Bag__CheckoutController from "./bag/checkout_controller"
application.register("bag--checkout", Bag__CheckoutController)

import Bag__CheckoutStateController from "./bag/checkout_state_controller"
application.register("bag--checkout-state", Bag__CheckoutStateController)

import Bag__CheckoutSummaryController from "./bag/checkout_summary_controller"
application.register("bag--checkout-summary", Bag__CheckoutSummaryController)

import Bag__PaymentMethodController from "./bag/payment_method_controller"
application.register("bag--payment-method", Bag__PaymentMethodController)

import Bag__Validators__CheckoutFormController from "./bag/validators/checkout_form_controller"
application.register("bag--validators--checkout-form", Bag__Validators__CheckoutFormController)

import ButtonSelectController from "./button_select_controller"
application.register("button-select", ButtonSelectController)

import CheckoutAddressAutocompleteController from "./checkout_address_autocomplete_controller"
application.register("checkout-address-autocomplete", CheckoutAddressAutocompleteController)

import CollectionController from "./collection_controller"
application.register("collection", CollectionController)

import CountryStateController from "./country_state_controller"
application.register("country-state", CountryStateController)

import Diamonds__FilterController from "./diamonds/filter_controller"
application.register("diamonds--filter", Diamonds__FilterController)

import Diamonds__MultiSelectController from "./diamonds/multi_select_controller"
application.register("diamonds--multi-select", Diamonds__MultiSelectController)

import EmbedSocialController from "./embed_social_controller"
application.register("embed-social", EmbedSocialController)

import EngravingController from "./engraving_controller"
application.register("engraving", EngravingController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlipperController from "./flipper_controller"
application.register("flipper", FlipperController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import GlossaryLookupController from "./glossary_lookup_controller"
application.register("glossary-lookup", GlossaryLookupController)

import GtmCheckoutController from "./gtm_checkout_controller"
application.register("gtm-checkout", GtmCheckoutController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KlaviyoCartController from "./klaviyo_cart_controller"
application.register("klaviyo-cart", KlaviyoCartController)

import ListGroupController from "./list_group_controller"
application.register("list-group", ListGroupController)

import MetalSelectorController from "./metal_selector_controller"
application.register("metal-selector", MetalSelectorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import PreciousMetalCalculatorController from "./precious_metal_calculator_controller"
application.register("precious-metal-calculator", PreciousMetalCalculatorController)

import Product360Controller from "./product_360_controller"
application.register("product-360", Product360Controller)

import ProfileBillingToggleController from "./profile_billing_toggle_controller"
application.register("profile-billing-toggle", ProfileBillingToggleController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import SearchResultsController from "./search_results_controller"
application.register("search-results", SearchResultsController)

import StoreSearchController from "./store_search_controller"
application.register("store-search", StoreSearchController)

import ShippingController from "./shipping_controller"
application.register("shipping", ShippingController)

import StonePriceUpdaterController from "./stone_price_updater_controller"
application.register("stone-price-updater", StonePriceUpdaterController)

import SwiperCollectionProductController from "./swiper_collection_product_controller"
application.register("swiper-collection-product", SwiperCollectionProductController)

import SwiperGalleryController from "./swiper_gallery_controller"
application.register("swiper-gallery", SwiperGalleryController)

import SwiperProductController from "./swiper_product_controller"
application.register("swiper-product", SwiperProductController)

import SwiperRecentlyController from "./swiper_recently_controller"
application.register("swiper-recently", SwiperRecentlyController)

import SwiperTestimonialsController from "./swiper_testimonials_controller"
application.register("swiper-testimonials", SwiperTestimonialsController)

import TextCounterController from "./text_counter_controller"
application.register("text-counter", TextCounterController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboStreamController from "./turbo_stream_controller"
application.register("turbo-stream", TurboStreamController)

import UrlSelectorController from "./url_selector_controller"
application.register("url-selector", UrlSelectorController)

import Validators__AccountShippingController from "./validators/account_shipping_controller"
application.register("validators--account-shipping", Validators__AccountShippingController)

import Validators__CartSigninController from "./validators/cart_signin_controller"
application.register("validators--cart-signin", Validators__CartSigninController)

import Validators__CartSignupController from "./validators/cart_signup_controller"
application.register("validators--cart-signup", Validators__CartSignupController)

import Validators__CdjFormController from "./validators/cdj_form_controller"
application.register("validators--cdj-form", Validators__CdjFormController)

import Validators__CheckoutBillingController from "./validators/checkout_billing_controller"
application.register("validators--checkout-billing", Validators__CheckoutBillingController)

import Validators__CheckoutShippingController from "./validators/checkout_shipping_controller"
application.register("validators--checkout-shipping", Validators__CheckoutShippingController)

import Validators__ContactController from "./validators/contact_controller"
application.register("validators--contact", Validators__ContactController)

import Validators__LoginController from "./validators/login_controller"
application.register("validators--login", Validators__LoginController)

import Validators__PasswordChangeController from "./validators/password_change_controller"
application.register("validators--password-change", Validators__PasswordChangeController)

import Validators__RegisterController from "./validators/register_controller"
application.register("validators--register", Validators__RegisterController)

import Validators__RingSizeController from "./validators/ring_size_controller"
application.register("validators--ring-size", Validators__RingSizeController)

import Validators__TestimonialController from "./validators/testimonial_controller"
application.register("validators--testimonial", Validators__TestimonialController)

import VariantNavigatorController from "./variant_navigator_controller"
application.register("variant-navigator", VariantNavigatorController)

import VariantUpdaterController from "./variant_updater_controller"
application.register("variant-updater", VariantUpdaterController)

import WishlistController from "./wishlist_controller"
application.register("wishlist", WishlistController)
